/*eslint-disable no-useless-escape */
/*eslint-disable prefer-const */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component, useState, useEffect, createRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Card,
  Row,
  Col,
  Button,
  Form,
  Modal,
  ButtonGroup,
  Tabs,
  Tab,
} from 'react-bootstrap';

import { CoveragesSVG } from '../../img/tab_icons/CoveragesSVG';
import { ClaimsSVG } from '../../img/tab_icons/ClaimsSVG';
import { AccountsSVG } from '../../img/tab_icons/AccountsSVG';
import { IDCardSVG } from '../../img/tab_icons/IDCardSVG';
import { DocumentsSVG } from '../../img/tab_icons/DocumentsSVG';
import { ClaimDetailsSVG } from '../../img/GlobalSVG';
import { ProfileSVG } from '../../img/tab_icons/ProfileSVG';
import { AccumulatorSVG } from '../../img/tab_icons/AccumulatorSVG';
import { DeLinkAccountSVG } from '../../img/tab_icons/DeLinkAccountSVG';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../api/APIEndpoints';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import RetryAPI from '../../api/RetryAPI';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import './member.scss';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../common/ToastMessage';
import 'react-toastify/dist/ReactToastify.css';
import ClientError from '../../errorhandling/ClientError';
import CustomError from '../../errorhandling/CustomError';
import MasterPermissions from '../../api/MasterPermissions';
import useDate from '../../utils/useDate';
import { axiosInstance } from '../../../api/axios';
import MemberDetailsSkeleton from './Skeleton/MemberDetailsInfoSkeleton';
import { setSelectedMember } from '../../../redux/admin/memberModule';
import { capitalizeFirstLetter } from '../../utils/strings';
import {
  resetActiveUser,
  resetClaimsResult,
  resetSearchParams,
} from 'src/redux/admin/claimsSlice';
import CustomClientError from '../../errorhandling/CustomClientError';
import UserDefinedLabels from '../../utils/UserDefinedLabels';
import ApiEncrypt from 'src/Admin/utils/Encrypt';
import { EditIcon, EditIconDynamic } from '../../img/Admin/BreadCrumbIcons';
import {
  getMemberUserAndMemberDetails,
  getMemberUserData,
} from 'src/redux/admin/api-calls/members';
import { USER_TYPES } from 'src/constants';
import {
  setUserDataIdMap,
  deleteDataOfEmail,
} from 'src/redux/admin/membersSlice';
import Feature from '../../../services/feature';
import { ActionMenus } from './ActionMenus';
import store from 'src/redux/store';
import CustomAutoSuggestSelectOptions from '../../components/common/CustomAutoSuggestSelectOption/custom-auto-suggest-select-options';

const noValue = 'Not Specified';
const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
let response = null,
  getUserResponse = null,
  getUserDataResp = null;
const MemberDetailsInfo = (props) => {
  const memberActionMenusRef = createRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [emailVal, setEmail] = useState();
  const [previousEmailId, setPreviousEmailId] = useState('');
  const [emailVal1, setEmail1] = useState();
  const [passwordVal, setPassword] = useState();
  const [phoneVal, setPhoneNumber] = useState();
  const [statusVal, setStatus] = useState('');
  const [loadingGetUser, setLoadingGetUser] = useState(false);
  const [clientError, setClientError] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [disabledValue, setdisabledValue] = useState(true);
  const [isEmailValid, setisEmailValid] = useState(false);
  const { userData = {} } = useSelector((state) => state.user || {});
  const [isAccountsVisible, setisAccountsVisible] = useState(false);
  const [isDocumentVisible, setIsDocumentVisible] = useState(false);
  const [isBenefitAccumsVisible, setIsBenefitAccumsVisible] = useState(false);
  const [memberID, setMemberID] = useState('');
  const [emailInitial, setEmailInitial] = useState('');
  const [emailInitial1, setEmailInitial1] = useState('');
  const [coverageDropDown, setCoverageDropDown] = useState([]);
  const [coverageMemberData, setCoverageMemberData] = useState([]);
  const [toggleMemberDetails, setToggleMemberDetail] = useState(false);
  const [selectedCoverageData, setSelectedCoverageData] = useState();
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const { encryptData } = ApiEncrypt();

  const [show, setShow] = useState(false);
  const { formatDate } = useDate();
  const { DefaultMemberIDKey } = UserDefinedLabels();

  const { oidMemberDataMap } = useSelector((state) => state.members || {});

  useEffect(() => {
    console.log('oidMemberDataMap >>>> ', oidMemberDataMap);
    const userData = oidMemberDataMap?.[props.userEmail]?.userData;

    if (userData) {
      setStatus(userData.Status);
    }
  }, [oidMemberDataMap, props.userEmail]);

  const handleClose = () => {
    setShow(false);
    setEmail(getUserDataResp.UserID);
    setPreviousEmailId(getUserDataResp.UserID);
    setdisabledValue(true);
  };
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setShow1(false);
    setEmail1(getUserDataResp.AltEmailID);
    setdisabledValue(true);
  };
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setStatus(getUserDataResp.Status);
  };
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => {
    setShow3(false);
    setPassword(getUserDataResp.Password);
    setdisabledValue(true);
  };
  const handleShow3 = () => setShow3(true);

  let viewClaim = false;
  let txnDetails = false;
  let viewCoverage = false;
  let viewMemRec = false;
  let viewIdCards = false;
  let viewDocument = false;
  let viewProfile = false;
  let viewAccumulators = false;
  const userTypeCheck = store.getState().user?.userData?.UserType;

  if (MasterPermissions.CheckPermission('View Member Record'))
    viewMemRec = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Coverage Details') &&
    (MasterPermissions.CheckPermission('Medical Coverage') ||
      MasterPermissions.CheckPermission('Dental Coverage') ||
      MasterPermissions.CheckPermission('Vision Coverage') ||
      MasterPermissions.CheckPermission('Prescription Coverage') ||
      MasterPermissions.CheckPermission('Long Term Disability Coverage') ||
      MasterPermissions.CheckPermission('Short Term Disability Coverage') ||
      MasterPermissions.CheckPermission('Supplemental Coverage'))
  )
    viewCoverage = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Claims')
  )
    viewClaim = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Spending Account Details')
  )
    txnDetails = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View ID Cards')
  )
    viewIdCards = true;

  if (MasterPermissions.CheckPermission('View Document')) viewDocument = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Accumulators')
  ) {
    viewAccumulators = true;
  }
  if (
    (userTypeCheck != 'Provider' &&
      MasterPermissions.CheckPermission('View Self Profile Information')) ||
    MasterPermissions.CheckPermission(' View Dependent Profile Information') ||
    MasterPermissions.CheckPermission('View HIPAA Patient Rights Information')
  )
    viewProfile = true;

  useEffect(() => {
    //window.scrollTo(0,0);
    setisAccountsVisible(false);
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'spendingAccount',
    );
    if (feature && feature.Status === false) {
      setisAccountsVisible(true);
    }
    if (props.userEmail) {
      getUserInformation(props.userEmail, true);
    } else {
      setLoadingGetUser(false);
    }
  }, [props.userEmail, props.infoUpdated]);
  useEffect(() => {
    setisAccountsVisible(false);
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'spendingAccount',
    );
    if (feature && feature.Status === false) {
      setisAccountsVisible(true);
    }
    //setLoadingGetUser(true);
  }, [props.uoid]);

  useEffect(() => {
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'SendDocument',
    );
    if (feature && feature.Status === true && viewDocument) {
      setIsDocumentVisible(true);
    }
  }, []);

  useEffect(() => {
    setCoverageMemberData([]);
    setSelectedCoverageData([]);
    setToggleMemberDetail(false);
  }, [coverageDropDown]);

  useEffect(() => {
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'BenefitAccumulator',
    );
    if (feature && feature.Status === true) {
      setIsBenefitAccumsVisible(true);
    }
  }, []);

  const getUserInformation = async (userEmail, hideLoader) => {
    const getUser = await Promise.all([GetUser(userEmail, hideLoader)]);
  };

  const setUserTab = (name) => {
    sessionStorage.setItem('user-tab', name);
    //Clearing previous claims store
    dispatch(resetActiveUser());
    dispatch(resetSearchParams());
    dispatch(resetClaimsResult());
  };

  const RegisterUpdate = async () => {
    try {
      const updateUser = {
        Oid: getUserDataResp.Oid,
        CurrentUserID: getUserDataResp.UserID,
        UserID: emailVal,
      };
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        {
          UpdateUser: updateUser,
        },
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        const dataUpdation = { ...oidMemberDataMap[props.userEmail] };
        const { memberData, userData } = { ...dataUpdation };
        const newMemberData = { ...userData, UserID: emailVal };
        const updatedData = {
          memberData: { ...memberData },
          userData: { ...newMemberData },
        };
        dispatch(setUserDataIdMap({ email: emailVal, data: updatedData }));
        dispatch(deleteDataOfEmail({ email: previousEmailId }));
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`${t('admin.pages.manage_member.registered_email')} ${t(
              'admin.toast_messages.updation_successful',
            )}`}
          />,
        );
        //props.updateCallback();
        props.updateSelectedMemberEmailID(props.userIndex, emailVal);
        handleClose();
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
      }
    } catch (error) {
      setEmail(emailInitial);
      setPreviousEmailId(emailInitial);
      toast.error(
        <ToastMessage
          type="error"
          //subTitle={`${ t( 'admin.toast_messages.updation_unsuccessful' ) } ${ t( 'admin.pages.manage_member.registered_email' ) }`}
          subTitle={error?.response?.data?.message}
        />,
      );
    } finally {
      setShow(false);
      setdisabledValue(true);
      //setEmail( emailVal );
    }
  };

  const AlternateEmailUpdate = async () => {
    try {
      const updateUser = {
        Oid: getUserDataResp.Oid,
        UserID: emailVal,
        AltEmailID: emailVal1,
      };
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        {
          UpdateUser: updateUser,
        },
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`${t('admin.pages.manage_member.alternate_email')} ${t(
              'admin.toast_messages.updation_successful',
            )}`}
          />,
        );
        props.updateCallback();
        handleClose1();
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
      }
    } catch (error) {
      setEmail1(emailInitial1);
      toast.error(
        <ToastMessage
          type="error"
          //subTitle={`${ t( 'admin.toast_messages.updation_unsuccessful' ) } ${ t( 'admin.pages.manage_member.alternate_email' ) }`}
          subTitle={error?.response?.data?.message}
        />,
      );
    } finally {
      setShow1(false);
      setdisabledValue(true);
      //setEmail1( emailVal1 );
    }
  };

  const ChangePassword = async () => {
    try {
      const updateUser = {
        Oid: getUserDataResp.Oid,
        UserID: emailVal,
        //ForcePasswordReset flag should be set to true while changing password (as per API implementation )
        ForcePasswordReset: true,
        Password: encryptData(passwordVal, false),
      };
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        {
          UpdateUser: updateUser,
        },
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`${t('admin.pages.manage_member.password')} ${t(
              'admin.toast_messages.updation_successful',
            )}`}
          />,
        );
        props.updateCallback();
        handleClose3();
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`${t('admin.toast_messages.updation_unsuccessful')} ${t(
            'admin.pages.manage_member.password',
          )}`}
        />,
      );
    } finally {
      setShow3(false);
      setdisabledValue(true);
      setPassword(passwordVal);
    }
  };

  const GetUser = async (userEmail, hideLoader) => {
    try {
      dispatch(getMemberUserData({ email: props.userEmail }));
      let responseNew;
      if (oidMemberDataMap[props.userEmail]) {
        setLoadingGetUser(false);
        setCustomError(false);
        setClientError(false);
        getUserDataResp = oidMemberDataMap[props.userEmail].userData;
        console.log(
          '&&&&&&&&&&&&&&&&&&&&&& ',
          oidMemberDataMap[props.userEmail].userData,
        );
      } else {
        //if (!hideLoader)
        setLoadingGetUser(true);
        responseNew = await getMemberUserAndMemberDetails(
          props.userEmail,
          true,
        );
        console.log('new approach response is >>>>>', responseNew);
        dispatch(
          setUserDataIdMap({ email: props.userEmail, data: responseNew.data }),
        );
        //Decrypt the response
        //const response = await axiosInstance.get(
        //cacheBuster(APIEndpoints.GetUser() + props.userEmail),
        //);

        //console.log('res 123 >>>> ', res123);
        //Decrypt the response
        //getUserDataResp = response.data;
        getUserDataResp = responseNew.data.userData;
        console.log('User Data 123 >>>>>', getUserDataResp);
      }

      if (
        responseNew?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        oidMemberDataMap[props.userEmail]
      ) {
        dispatch(
          setSelectedMember({
            ID: getUserDataResp?.MemberDetails?.MemberOID,
            mType: getUserDataResp?.MemberDetails?.MemberType,
            label: getUserDataResp?.MemberDetails?.MemberType,
          }),
        );

        CookiesService.set('UserOid', getUserDataResp.Oid);
        CookiesService.set(
          'MemberOid',
          getUserDataResp.MemberDetails.MemberOID,
        );
        CookiesService.set('MemberUserType', getUserDataResp.UserType);
        CookiesService.remove('MemberName');
        CookiesService.set(
          'MemberName',
          getUserDataResp.FirstName + ' ' + getUserDataResp.LastName,
        );
        CookiesService.set('MemberID', props.userEmail);

        setStatus(getUserDataResp.Status);
        setEmail(getUserDataResp.UserID);
        setPreviousEmailId(getUserDataResp.UserID);
        setEmailInitial(getUserDataResp.UserID);
        setEmail1(getUserDataResp.AltEmailID);
        setEmailInitial1(getUserDataResp.AltEmailID);
        setPhoneNumber(getUserDataResp.CellPhone);
        setPassword(getUserDataResp.Password);
        getMemberID(getUserDataResp.MemberDetails);
        setCoverageDropDown(getUserDataResp?.MemberDetailsList);

        //RetryAPI.resetRetryCount();
        //RetryAPI.setResponseReceived(true);
        setLoadingGetUser(false);
        setCustomError(false);
      } else {
        //RetryAPI.setResponseReceived(false);
        //RetryAPI.setErrorCode(response.status);
        setLoadingGetUser(false);
        //const errorCode = RetryAPI.getErrorCode();
        const errorCode = 500;
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to get user details now.',
          )
        ) {
          //setServerError(true);
          setCustomError(true);
        }
      }
    } catch (error) {
      let errorMessage = '';
      //var requestAborted = '';

      RetryAPI.setResponseReceived(false);
      setLoadingGetUser(false);
      RetryAPI.setErrorCode(error?.response?.status);
      const errorCode = RetryAPI.getErrorCode();
      if (errorCode == 404) {
        toast.error(
          <ToastMessage
            type="error"
            title="Email ID Validation"
            subTitle="Email address provided was not found. Please use correct email or contact administrator."
          />,
        );
      } else {
        console.log('Get User Exception: ', error);
        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          console.log('Data: ', error.response.data);
          console.log('Header: ', error.response.headers);
          console.log('Status: ', error.response.status);
          RetryAPI.setErrorCode(error.response.status);
        }

        //if (axios.isCancel(error)) {
        //console.log('Previous request canceled, new request is send', error.message);
        //}

        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to get user details now.',
          )
        ) {
          //setServerError(true);
          setCustomError(true);
        }
      }
    }
  };

  const updateUserAPI = async () => {
    if (statusVal === getUserDataResp.Status || statusVal === '') {
      toast.info(
        <ToastMessage
          type="info"
          subTitle={t('admin.pages.manage_member.user_status_unchanged')}
        />,
      );
      handleClose2();
      return;
    }

    //const bearerToken = CookiesService.get('loginToken');
    try {
      const updateUser = {
        Oid: getUserDataResp.Oid,
        UserID: getUserDataResp.UserID,
        Status: statusVal,
      };
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        {
          UpdateUser: updateUser,
        },
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        const dataUpdation = { ...oidMemberDataMap[props.userEmail] };
        const { memberData, userData } = { ...dataUpdation };
        const newMemberData = { ...userData, Status: statusVal };
        const updatedData = {
          memberData: { ...memberData },
          userData: { ...newMemberData },
        };
        console.log(updatedData);
        dispatch(
          setUserDataIdMap({ email: props.userEmail, data: updatedData }),
        );
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`${t('admin.pages.manage_member.user_status')} ${t(
              'admin.toast_messages.updation_successful',
            )}`}
          />,
        );
        props.updateCallback();
        handleClose2();
      } else {
        HttpErrorHandler.DisplayServerErrorMessage(response.status, '');
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`${t('admin.toast_messages.updation_unsuccessful')} ${t(
            'admin.pages.manage_member.user_status',
          )}`}
        />,
      );
    }
  };

  const delinkAccountAPI = async () => {
    let updateUser = {
      Oid: oidMemberDataMap[props.userEmail].userData?.Oid,
      UserType: 'multimember',
      UserID: oidMemberDataMap[props.userEmail].userData?.UserID,
      FirstName:
        oidMemberDataMap[props.userEmail].userData?.FirstName ||
        oidMemberDataMap[props.userEmail].userData?.firstName,
      MiddleName:
        oidMemberDataMap[props.userEmail].userData?.MiddleName ||
        oidMemberDataMap[props.userEmail].userData?.middleName,
      LastName:
        oidMemberDataMap[props.userEmail].userData?.LastName ||
        oidMemberDataMap[props.userEmail].userData?.lastName,
      Status: oidMemberDataMap[props.userEmail].userData?.Status,
    };
    const updateMappedEnties =
      coverageDropDown &&
      coverageDropDown.filter(
        (item) => coverageMemberData?.[0]?.MemberID !== item?.MemberID,
      );
    updateUser = {
      ...updateUser,
      MappedEnties: updateMappedEnties.map((item) => {
        return {
          [item?.MemberType === 'Dependent' ? 'DependentOid' : 'MemberOid']:
            item?.MemberOID,
          DefaultProfile: item?.DefaultProfile,
        };
      }),
    };

    const reduxDataToUpdate = {
      ...oidMemberDataMap[props.userEmail],
      userData: {
        ...oidMemberDataMap[props.userEmail].userData,
        MemberDetailsList: updateMappedEnties,
      },
    };
    console.log('debug=>Redux', reduxDataToUpdate);
    try {
      const response = await axiosInstance.put(
        APIEndpoints.getUpdateUserAPIResource(),
        {
          UpdateUser: updateUser,
        },
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'You have successfully de-linked this account.'}
          />,
        );
        dispatch(
          setUserDataIdMap({
            email: props.userEmail,
            data: reduxDataToUpdate,
          }),
        );
        setCoverageMemberData([]);
        setSelectedCoverageData([]);
        setCoverageDropDown(updateMappedEnties);
        setToggleMemberDetail(false);
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            'We are unable to de-link this account. Try after sometime.'
          }
        />,
      );
    }
  };

  const checkUpdateStatus = (result, email) => {
    if (result != true) {
      setdisabledValue(true);
      setisEmailValid(true);
    } else if (email == '') {
      setdisabledValue(true);
      setisEmailValid(true);
    } else {
      setdisabledValue(false);
      setisEmailValid(false);
    }
  };
  const onChangeRegisteredEmail = (e) => {
    const registeredEmail = e.currentTarget.value;
    const result = validateEmail(registeredEmail);
    checkUpdateStatus(result, registeredEmail);
    setEmail(e.currentTarget.value);
  };

  const onChangeAlternateEmail = (e) => {
    const alternateEmail = e.currentTarget.value;
    const result = validateEmail(alternateEmail);
    checkUpdateStatus(result, alternateEmail);
    setEmail1(alternateEmail);
  };

  const onChangePassword = (e) => {
    if (e.currentTarget.value != '') {
      setdisabledValue(false);
    } else {
      setdisabledValue(true);
    }
    setPassword(e.currentTarget.value);
  };

  const validateEmail = (str) => {
    const regex = new RegExp(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    );
    const val = regex.test(str);
    return val;
  };

  const getMemberID = (memberDetails) => {
    const key =
      DefaultMemberIDKey &&
      DefaultMemberIDKey.charAt(0).toUpperCase() + DefaultMemberIDKey.slice(1);
    console.log('DefaultMemberIDKey >>>>>', DefaultMemberIDKey);
    console.log('DefaultMemberIDKey key >>>>>', key);
    setMemberID(memberDetails[key]);
  };

  const enrollmentHandler = () => {
    console.log('Enrollment clicked ::::  ');
    navigate({ pathname: '/admin/enrollment-life-event' });
  };

  //Custom AutoSuggestSelect Option start
  const LinkIcon = () => {
    return (
      <svg
        width="20"
        height="10"
        viewBox="0 0 20 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 10H5C3.61667 10 2.4375 9.5125 1.4625 8.5375C0.4875 7.5625 0 6.38333 0 5C0 3.61667 0.4875 2.4375 1.4625 1.4625C2.4375 0.4875 3.61667 0 5 0H9V2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H9V10ZM6 6V4H14V6H6ZM11 10V8H15C15.8333 8 16.5417 7.70833 17.125 7.125C17.7083 6.54167 18 5.83333 18 5C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H11V0H15C16.3833 0 17.5625 0.4875 18.5375 1.4625C19.5125 2.4375 20 3.61667 20 5C20 6.38333 19.5125 7.5625 18.5375 8.5375C17.5625 9.5125 16.3833 10 15 10H11Z"
          fill="#007E33"
        />
      </svg>
    );
  };

  const affiliateAccountOption = {
    client: 'Affiliate Account',
    userType: null,
    value: '',
    status: null,
  };

  const accountOptions =
    (coverageDropDown.length > 0 &&
      coverageDropDown.map((item) => {
        return {
          ...item,
          client: item?.ClientName,
          value: item?.ClientName,
          userType:
            item?.MemberType === 'Employee' ? 'Member' : item?.MemberType,
          status: item?.CoverageStatus,
        };
      })) ||
    [];
  //#TODO: Need to uncomment it later as we need this functionality in next phase
  if (MasterPermissions.CheckPermission('Affiliate Dual Coverage'))
    accountOptions.push(affiliateAccountOption);

  const formatOptionLabel = ({ value, client, userType, status }) => (
    <div className="custom-option-label">
      {client !== 'Affiliate Account' ? (
        <>
          <div className="option-label">
            {client} <span className="option-user-type">({userType})</span>
          </div>
          <div
            className={`option-status ${
              status === 'Active' ? 'active-status' : 'other-status'
            }`}
          >
            {status}
          </div>
        </>
      ) : (
        <>
          <div
            className="option-label-last d-flex"
            style={{ position: 'relative' }}
          >
            <div
              className="pb-2 pr-2"
              style={{ top: '-2px', position: 'relative' }}
            >
              <LinkIcon />
            </div>
            <div>{client}</div>
          </div>
        </>
      )}
    </div>
  );

  const onChangeHandler = (e) => {
    const coverageDropDownData =
      coverageDropDown &&
      coverageDropDown.filter((item) => e.MemberID === item?.MemberID);
    setCoverageMemberData(coverageDropDownData);
    coverageDropDownData && coverageDropDownData.length > 0
      ? setToggleMemberDetail(true)
      : setToggleMemberDetail(false);
    if (
      e.client === 'Affiliate Account' &&
      coverageDropDownData &&
      coverageDropDownData.length === 0
    ) {
      const userData = oidMemberDataMap[props.userEmail]
        ? oidMemberDataMap[props.userEmail].userData
        : {};
      navigate('/admin/affiliate-account', {
        state: {
          userDataRedux: userData,
          searchText: props.searchText,
          pageSize: props.pageSize,
          activePage: props.activePage,
          isRegistered: props.isRegisterd,
          userIndex: props.userIndex,
          selectedUserEmail: props.userEmail,
          selectedUserFirstName: getUserDataResp.FirstName,
          selectedUserLastName: getUserDataResp.LastName,
        },
      });
    }

    dispatch(
      setSelectedMember({
        ID: e?.MemberOID,
        mType: e?.MemberType,
        label: e?.MemberType,
      }),
    );
  };

  //Custom AutoSuggestSelect Option End

  return (
    <div className="usermanager-info member-mgt-container 123">
      {loadingGetUser && <MemberDetailsSkeleton />}
      {!loadingGetUser && !clientError && !customError && getUserDataResp && (
        <div>
          <div>
            <Row className="pb-2">
              <Col md={2}>
                <span className="mgt-user-icon-img-large">
                  {getUserDataResp.FirstName.charAt(0) +
                    getUserDataResp.LastName.charAt(0)}
                </span>
              </Col>
              <Col md={4}>
                <h3 className="mb-0 usermanager-info-username">
                  {capitalizeFirstLetter(getUserDataResp.FirstName)}
                  &nbsp;
                  {capitalizeFirstLetter(getUserDataResp.LastName)}
                </h3>
                <p>{props.userEmail}</p>
              </Col>
              {viewMemRec && (
                <Col md={6}>
                  <Feature name="EnrollmentLifeChangeEventAdmin">
                    {MasterPermissions.CheckPermission('Perform Enrollment') &&
                      getUserDataResp.UserType == USER_TYPES.EMPLOYEE && (
                        <div className="quick-menu-container">
                          <ActionMenus
                            ref={memberActionMenusRef}
                            enrollmentHandler={enrollmentHandler}
                            otherActionItems={false}
                          />
                        </div>
                      )}
                  </Feature>
                  <div className="account-status-container">
                    <Form.Group controlId="memberEmail">
                      <Form.Label>
                        {t('admin.pages.manage_member.member_acc_status')}
                      </Form.Label>
                      {/*<Form.Control type="email" value={statusVal} className="editField"  onClick={handleShow2} /> */}
                      <p
                        className={
                          statusVal == 'Active'
                            ? 'status-value status-value-Active'
                            : 'status-value status-value-Disabled'
                        }
                      >
                        {statusVal}
                        {MasterPermissions.CheckPermission(
                          'Edit Members/Dependents Users',
                        ) ||
                        MasterPermissions.CheckPermission('Change Status') ? (
                          <span className={'pointer'} onClick={handleShow2}>
                            <EditIconDynamic className={'notification-SVG'} />
                          </span>
                        ) : (
                          <span className={'px-2'}>
                            <EditIconDynamic className={'socialIcons-SVG'} />
                          </span>
                        )}
                      </p>
                    </Form.Group>
                  </div>
                </Col>
              )}
            </Row>
          </div>
          <div className="grpDivider"></div>
          <div className="grpDivider"></div>
          <div className="mb-3">
            <Row className="memberData">
              <Col>
                <h3>Account Information</h3>
              </Col>
            </Row>
            <Row>
              <Col md="8">
                <Form.Label>Select Employer</Form.Label>
                <CustomAutoSuggestSelectOptions
                  options={accountOptions}
                  formatOptionLabel={formatOptionLabel}
                  onChange={onChangeHandler}
                  selectedCoverageData={selectedCoverageData}
                  setSelectedCoverageData={setSelectedCoverageData}
                  //accountType={accountType}
                  //setAccountType={setAccountType}
                />
              </Col>
              <Col md="4"></Col>
            </Row>
          </div>
          <div className="grpDivider"></div>
          {toggleMemberDetails && (
            <div>
              <Row className="member-details-container">
                <Col className="status-field1">Member ID</Col>
                <Col className="status-value1">
                  {coverageMemberData[0]?.MemberID}
                </Col>
                <Col className="status-field1">Status</Col>
                <Col
                  className={`status-value1 ${
                    coverageMemberData[0]?.CoverageStatus == 'Active'
                      ? 'active-status'
                      : 'other-status'
                  }`}
                >
                  {coverageMemberData[0]?.CoverageStatus}
                </Col>
                {/*<Col
                className={`status-value1 ${
                  accountType?.status == 'Active'
                    ? 'active-status'
                    : 'other-status'
                }`}
              >
                {accountType.status}
              </Col> */}
              </Row>
              <Row className="member-details-container">
                <Col className="status-field1">User Type</Col>
                <Col className="status-value1">
                  {coverageMemberData[0]?.MemberType
                    ? coverageMemberData[0]?.MemberType == 'Employee'
                      ? 'Member'
                      : coverageMemberData[0]?.MemberType
                    : noValue}
                </Col>
                <Col className="status-field1"></Col>
                <Col className="status-value1"></Col>
              </Row>
              <Row className="member-details-container">
                <Col className="status-field1">Email ID</Col>
                <Col className="status-value1">
                  {emailVal ? emailVal : noValue}
                </Col>
                <Col className="status-field1"></Col>
                <Col className="status-value1"></Col>
              </Row>
              <div className="grpDivider"></div>
              {/*<Row className="memberData mt-50">
                <Col>
                  <h3>{t('admin.pages.manage_member.active_coverages')}</h3>
                </Col>
              </Row>*/}
              <div className="d-flex flex-wrap">
                {viewCoverage && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName: getUserDataResp.FirstName,
                          selectedUserLastName: getUserDataResp.LastName,
                        }}
                      >
                        <div
                          className=""
                          onClick={() => setUserTab('coverages')}
                        >
                          <CoveragesSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.coverage')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {viewClaim && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName: getUserDataResp.FirstName,
                          selectedUserLastName: getUserDataResp.LastName,
                        }}
                      >
                        <div className="" onClick={() => setUserTab('claims')}>
                          <ClaimsSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.claims')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {txnDetails &&
                  !isAccountsVisible &&
                  getUserDataResp.UserType != 'Dependent' && (
                    <div className="col-arrange">
                      <div className="memberBox">
                        <Link
                          to={'/admin/view-member'}
                          state={{
                            searchText: props.searchText,
                            pageSize: props.pageSize,
                            activePage: props.activePage,
                            isRegistered: props.isRegisterd,
                            userIndex: props.userIndex,
                            selectedUserEmail: props.userEmail,
                            selectedUserFirstName: getUserDataResp.FirstName,
                            selectedUserLastName: getUserDataResp.LastName,
                          }}
                        >
                          <div
                            className=""
                            onClick={() => setUserTab('acsummary')}
                          >
                            <AccountsSVG className="svg-icons" />
                            <span className="accums-label-text">
                              {t('admin.pages.manage_member.acc_summary')}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                {viewIdCards && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName: getUserDataResp.FirstName,
                          selectedUserLastName: getUserDataResp.LastName,
                        }}
                      >
                        <div className="" onClick={() => setUserTab('idcards')}>
                          <IDCardSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.id_card')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {isDocumentVisible && viewDocument && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName: getUserDataResp.FirstName,
                          selectedUserLastName: getUserDataResp.LastName,
                        }}
                      >
                        <div
                          className=""
                          onClick={() => setUserTab('documents')}
                        >
                          <DocumentsSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.documents')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {viewProfile &&
                  ['Insurer', 'Client', 'Provider', 'Broker'].includes(
                    userData?.UserType,
                  ) && (
                    <div className="col-arrange">
                      <div className="memberBox">
                        <Link
                          to={'/admin/view-member'}
                          state={{
                            searchText: props.searchText,
                            pageSize: props.pageSize,
                            activePage: props.activePage,
                            isRegistered: props.isRegisterd,
                            userIndex: props.userIndex,
                            selectedUserEmail: props.userEmail,
                            selectedUserFirstName: getUserDataResp.FirstName,
                            selectedUserLastName: getUserDataResp.LastName,
                          }}
                        >
                          <div
                            className=""
                            onClick={() => setUserTab('profile')}
                          >
                            <ProfileSVG className="svg-icons" />
                            <span className="accums-label-text">
                              {t('admin.pages.manage_member.view_profile')}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                {isBenefitAccumsVisible &&
                  viewAccumulators &&
                  getUserDataResp.UserType != 'Dependent' && (
                    <div className="col-arrange">
                      <div className="memberBox">
                        <Link
                          to={'/admin/view-member'}
                          state={{
                            searchText: props.searchText,
                            pageSize: props.pageSize,
                            activePage: props.activePage,
                            isRegistered: props.isRegisterd,
                            userIndex: props.userIndex,
                            selectedUserEmail: props.userEmail,
                            selectedUserFirstName: getUserDataResp.FirstName,
                            selectedUserLastName: getUserDataResp.LastName,
                          }}
                        >
                          <div
                            className=""
                            onClick={() => setUserTab('accumulators')}
                          >
                            <AccumulatorSVG className="svg-icons" />
                            <span className="accums-label-text">
                              {t('admin.pages.manage_member.accumulators')}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  )}
                {/*#TODO : Need to uncomment later as we need to deploy this in next phase */}
                {MasterPermissions.CheckPermission(
                  'De-link existing Affiliated record',
                ) &&
                  coverageMemberData?.length &&
                  coverageMemberData?.[0]?.DefaultProfile !== true && (
                    <div className="col-arrange">
                      <div className="memberBox">
                        <div
                          style={{ cursor: 'pointer' }}
                          className=""
                          onClick={() => delinkAccountAPI()}
                        >
                          <DeLinkAccountSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.de_link_button')}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <br></br>
              <div className="grpDivider"></div>
              <Row>
                <Col>
                  <Modal
                    show={show}
                    onHide={handleClose}
                    centered
                    className="memberModal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title className="memberTitle">
                        {t('admin.pages.manage_member.update_reg_email')}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="memberBtn">
                      <Form.Group controlId="memberEmailPop">
                        <Form.Label>
                          {t('admin.pages.manage_member.registered_email')}
                        </Form.Label>
                        <Form.Control
                          type="email"
                          autoComplete="off"
                          value={emailVal}
                          onChange={onChangeRegisteredEmail}
                        />
                      </Form.Group>
                      {isEmailValid == true ? (
                        <span className="invalidUrl" role="alert">
                          {' '}
                          {t('admin.pages.manage_member.valid_email')}{' '}
                        </span>
                      ) : null}
                    </Modal.Body>
                    <Modal.Footer className="registeredEmailFooter">
                      <Button
                        variant="secondary"
                        className="cancel-btn"
                        onClick={handleClose}
                      >
                        {t('label_cancel')}
                      </Button>
                      <Button
                        variant="primary"
                        className="change-btn mr-0"
                        onClick={RegisterUpdate}
                        disabled={disabledValue}
                      >
                        {t('label_update')}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={show1}
                    onHide={handleClose1}
                    centered
                    className="memberModal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title className="memberTitle">
                        {t('admin.pages.manage_member.update_alt_email')}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="memberBtn">
                      <Form.Group controlId="memberEmailPop">
                        <Form.Label>
                          {t('admin.pages.manage_member.alternate_email')}
                        </Form.Label>
                        <Form.Control
                          type="email"
                          autoComplete="off"
                          value={emailVal1}
                          onChange={onChangeAlternateEmail}
                        />
                      </Form.Group>
                      {isEmailValid == true ? (
                        <span className="invalidUrl" role="alert">
                          {' '}
                          {t('admin.pages.manage_member.valid_email')}{' '}
                        </span>
                      ) : null}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="cancel-btn"
                        onClick={handleClose1}
                      >
                        {t('label_cancel')}
                      </Button>
                      <Button
                        variant="primary"
                        onClick={AlternateEmailUpdate}
                        className="change-btn mr-0"
                        disabled={disabledValue}
                      >
                        {t('label_update')}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={show2}
                    onHide={handleClose2}
                    className="memberModal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title className="memberTitle">
                        {' '}
                        {t('admin.pages.manage_member.change_acc_status')}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="memberBtn">
                      <p>{t('admin.pages.manage_member.acc_status')}</p>
                      <Tabs
                        defaultActiveKey={statusVal}
                        id="uncontrolled-tab-example"
                        onSelect={(k) => setStatus(k)}
                      >
                        <Tab eventKey="Active" title="Active"></Tab>
                        <Tab eventKey="Locked" title="Locked"></Tab>
                        <Tab eventKey="Disabled" title="Disabled"></Tab>
                      </Tabs>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="cancel-btn"
                        onClick={handleClose2}
                      >
                        {t('label_cancel')}
                      </Button>
                      <Button
                        variant="primary"
                        className="change-btn mr-0"
                        onClick={updateUserAPI}
                      >
                        {t('label_change')}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={show3}
                    onHide={handleClose3}
                    centered
                    className="memberModal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title className="memberTitle">
                        {t('admin.pages.manage_member.change_password')}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="memberBtn">
                      <Form.Group controlId="memberEmailPop">
                        <Form.Label>
                          {t('admin.pages.manage_member.password')}
                        </Form.Label>
                        <Form.Control
                          type="password"
                          autoComplete="new-password"
                          value={passwordVal}
                          onChange={onChangePassword}
                        />
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="cancel-btn"
                        onClick={handleClose3}
                      >
                        {t('label_cancel')}
                      </Button>
                      <Button
                        variant="primary"
                        className="change-btn mr-0"
                        onClick={ChangePassword}
                        disabled={disabledValue}
                      >
                        {t('label_update')}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
      <div>
        {!loadingGetUser && clientError && (
          <CustomClientError
            CustomClasses="p-0"
            ErrorHeading="No Members found!"
            ErrorMessage="We are unable to get member details."
          />
        )}
        {!loadingGetUser && customError && (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
          />
        )}
      </div>
    </div>
  );
};

export default MemberDetailsInfo;
